// extracted by mini-css-extract-plugin
export var aiStarSpin = "_p3-1";
export var spinner = "_p3-0";